export default `
  mutation(
    $session_id: String!,
    $version: String!,
    $event: String!,
    $page: String,
    $search: String!,
    $from: String,
    $date: Float!,
    $agent: String!,
    $device: String!,
    $type: String!,
    $detail:  String!,
  ) {
    insertStatistics(objEvent: {
      session_id: $session_id,
      version: $version,
      event: $event,
      page: $page,
      search: $search,
      from: $from,
      date: $date,
      agent: $agent,
      device: $device,
      type: $type,
      detail: $detail
    }) {
      status
    }
  }
`;
